const log_response = state => state.log_response;

export {
    log_response
}
